export const visioCropTranslationFr = {
  'fields.form.visio_crop.processing_engine_ref.label': 'Type de processus Visio Crop',
  'processingEngineType.vc-rapeseed-fertilization.label': 'Fertilisation de colza',
  'processingEngineType.vc-phenology.label': 'Phénologie',
  'field_process_job.table.title': 'Traitements Visio Crop',
  'field_process_job.table.created_at_column.title': 'Date de création',
  'field_process_job.table.status_column.title': 'Statut',
  'field_process_job.table.ended_at_column.title': 'Date de fin',
  'field_process_job.table.duration_column.title': 'Durée',
  'field_process_job.generate.button.label': 'Générer livrable',
  'field_process_job.execute.button.label': 'Exécuter un traitement',
  'visio-crop-nav-processes': 'Traitements Visio Crop',
  'visio-crop-nav-statistics': 'Statistiques',
  'indicator.ndvi.label': 'NDVI',
  'indicator.rapeseed_fertilization.label': 'Fertilization Colza',
  'processingEngineType.ndvi.label': 'NDVI',
  'processingEngineType.rapeseed_fertilization.label': 'Fertilization Colza',
  'visio_crop.processing.execute.rapeseed_fertilization.field-usage': 'Utilisation de la fertilisation',
  'visio_crop.processing.execute.field_use.date': 'Date de semis',
  'visio_crop.processing.execute.field_use.harvest_date': 'Date de récolte',
  'visio_crop.processing.execute.field_use.cropping_system': 'Système cultural',
  'visio_crop.processing.execute.field_use.crop': 'Culture',
  'visio_crop.processing.execute.field_use.yield': 'Objectif de rendement (q/ha)',
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters': 'Paramètres de traitement',
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.ew_data': "Paramètres d'entrée d'hiver",
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.lw_data': "Paramètres de sortie d'hiver",
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.switch.use_value':
    'Utiliser une valeur personnalisée',
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.switch.use_ratser':
    'Utiliser une image existante',
  'visio_crop.processing.execute.rapeseed_fertilization.button.label': 'Exécuter',
  'field_process_job.execute.modal.title': 'Exécuter un traitement Visio Crop',
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.lw_input_label': 'NDVI',
  'visio_crop.processing.execute.rapeseed_fertilization.override-parameters.ew_input_label': 'NDVI',
  'field_process_job.execute.modal.subtitle': 'Parcelle : {field}',
  'admin.report.statistics.title': 'Statistiques',
  'admin.report.status.completed': 'Terminé',
  'fields.form.cropping_system': 'Système cultural',
  'visioCrop.field.form.yield_target': 'Objectif de rendement (q/ha)',
  'admin.report.excel.title': 'Tableur',
  'visiocrop.processsjob-modal.download.button.label': 'Télécharger',
};
